import { CONFIG } from '../core/config';
import { StaticLookup } from './static-lookup';

export class StaticLookupAsync extends StaticLookup {
  apiRoute: string = CONFIG.apiRoutes.lookupAsync;
}
